module.exports = __webpack_public_path__ + "static/media/corporate_business_planning.dbef1013.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/corporate_business_planning.png
// module id = 496
// module chunks = 0